import { render, staticRenderFns } from "./AboutUsPhoto.vue?vue&type=template&id=3fb01c19&scoped=true&"
import script from "./AboutUsPhoto.vue?vue&type=script&lang=js&"
export * from "./AboutUsPhoto.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsPhoto.vue?vue&type=style&index=0&id=3fb01c19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb01c19",
  null
  
)

export default component.exports